// The Uzeli plan ladder: device count -> plan, monthly fee and display name.
//
// This lived twice, once in useDeviceCounter and once in RecommendDevices, and
// the copies had already drifted: the hook rendered "Uzeli Duo ($139)" while
// the recommendation rendered "Uzeli Duo", and only the hook counted a
// customer-supplied tablet as a device. Both now call this.
//
// planType is the customer-facing label and carries the price; uzeliPlan is the
// internal plan key and never does.
export const getPlanForDevices = ({
  deviceCount,
  totalSmartCheckout = 0,
  totalKiozzkCount = 0,
  totalComputer = 0,
}) => {
  let monthlyFee = 0;
  let planType = "";
  let uzeliPlan = "";
  switch (deviceCount) {
    case 0:
      monthlyFee = 0;
      planType = "Not selected";
      uzeliPlan = "Not selected";
      break;
    case 1:
      if (totalSmartCheckout === 1) {
        monthlyFee = 99;
        planType = "Smart Checkout ($99)";
        uzeliPlan = "Smart Checkout";
      } else {
        monthlyFee = 99;
        planType = "Uzeli Solo ($99)";
        uzeliPlan = "Uzeli Solo";
      }
      break;
    case 2:
      if (totalSmartCheckout === 0) {
        monthlyFee = 139;
        planType = "Uzeli Duo ($139)";
        uzeliPlan = "Uzeli Duo";
      } else if (totalKiozzkCount || totalComputer === 1) {
        monthlyFee = 139;
        planType = "Uzeli Solo + Smart Checkout ($139)";
        uzeliPlan = "Uzeli Solo + Smart Checkout";
      } else {
        monthlyFee = 139;
        planType = "Uzeli Duo + Smart Checkout ($139)";
        uzeliPlan = "Uzeli Duo + Smart Checkout";
      }
      break;
    case 3:
      if (totalSmartCheckout !== 0) {
        monthlyFee = 169;
        planType = "Uzeli Pro ($169)";
        uzeliPlan = "Uzeli Pro - 3 Devices";
      } else {
        monthlyFee = 169;
        planType = "Uzeli Duo + Smart Checkout ($169)";
        uzeliPlan = "Uzeli Duo + Smart Checkout";
      }
      break;
    case 4:
      monthlyFee = 189;
      planType = "Uzeli Pro ($189)";
      uzeliPlan = "Uzeli Pro - 4 Devices";
      break;
    case 5:
      monthlyFee = 199;
      planType = "Uzeli Pro ($199)";
      uzeliPlan = "Uzeli Pro - 5 Devices";
      break;
    case 6:
      monthlyFee = 209;
      planType = "Uzeli Pro ($209)";
      uzeliPlan = "Uzeli Pro - 6 Devices";
      break;
    case 7:
      monthlyFee = 219;
      planType = "Uzeli Pro ($219)";
      uzeliPlan = "Uzeli Pro - 7 Devices";
      break;
    case 8:
      monthlyFee = 229;
      planType = "Uzeli Pro ($229)";
      uzeliPlan = "Uzeli Pro - 8 Devices";
      break;
    case 9:
      monthlyFee = 239;
      planType = "Uzeli Pro ($239)";
      uzeliPlan = "Uzeli Pro - 9 Devices";
      break;
    case 10:
      monthlyFee = 249;
      planType = "Uzeli Pro ($249)";
      uzeliPlan = "Uzeli Pro - 10 Devices";
      break;
    case 11:
      monthlyFee = 259;
      planType = "Uzeli Pro ($259)";
      uzeliPlan = "Uzeli Pro - 11 Devices";
      break;
    case 12:
      monthlyFee = 269;
      planType = "Uzeli Pro ($269)";
      uzeliPlan = "Uzeli Pro - 12 Devices";
      break;
    case 13:
      monthlyFee = 279;
      planType = "Uzeli Pro ($279)";
      uzeliPlan = "Uzeli Pro - 13 Devices";
      break;
    case 14:
      monthlyFee = 289;
      planType = "Uzeli Pro ($289)";
      uzeliPlan = "Uzeli Pro - 14 Devices";
      break;
    case 15:
      monthlyFee = 299;
      planType = "Uzeli Pro ($299)";
      uzeliPlan = "Uzeli Pro - 15 Devices";
      break;
    case 16:
      monthlyFee = 309;
      planType = "Uzeli Pro ($309)";
      uzeliPlan = "Uzeli Pro - 16 Devices";
      break;
    case 17:
      monthlyFee = 319;
      planType = "Uzeli Pro ($319)";
      uzeliPlan = "Uzeli Pro - 17 Devices";
      break;
    case 18:
      monthlyFee = 329;
      planType = "Uzeli Pro ($329)";
      uzeliPlan = "Uzeli Pro - 18 Devices";
      break;
    case 19:
      monthlyFee = 339;
      planType = "Uzeli Pro ($339)";
      uzeliPlan = "Uzeli Pro - 19 Devices";
      break;
    case 20:
      monthlyFee = 349;
      planType = "Uzeli Pro ($349)";
      uzeliPlan = "Uzeli Pro - 20 Devices";
      break;
    default:
      monthlyFee = 299;
      planType = "Uzeli Pro ($299)";
  }

  return { monthlyFee, planType, uzeliPlan };
};
